<template>
  <v-layout
    :column="$vuetify.breakpoint.xsOnly"
    :class="['ticket-price-container-step-zkm', !isZkm && 'ticket-price-container-step-regular']"
    :style="{
      'border-top':
        isZkm && event.extraModules.ticketing && shoppingCart.length !== 0 && activeStep !== 1
          ? 'none'
          : '',
    }"
  >
    <v-flex>
      <v-layout row wrap :class="[isZkm && 'layout-zkm']">
        <div v-if="shoppingCart.length !== 0" class="regular-layout-container">
          <div class="price-container-title-regular">
            <span class="cart-title">
              {{ $t('cart') }}
            </span>
            <main-button
              v-if="activeStep !== 1 && !hideEditButton"
              class="edit-cart"
              color="black"
              outline
              @click="$emit('back')"
            >
              {{ $t('editShoppingCart') }}
              <v-icon style="margin-left: 8px" size="18">edit</v-icon>
            </main-button>
          </div>

          <div
            :class="[
              'header-description',
              isZkm && 'header-description-zkm',
              !isZkm && 'header-description-regular',
            ]"
          >
            <div class="zkm-price-table">
              <table class="wp-table">
                <tr class="ticket-list-header">
                  <th class="header-title">{{ $t('ticketType') }}</th>
                  <th class="header-title">{{ $t('ticketQuantity') }}</th>
                  <th style="text-align: right; padding-right: 0" class="header-title">
                    {{ $t('price') }}
                  </th>
                </tr>
                <tr
                  v-for="ticket in countDuplicate(selectedTickets)"
                  :key="ticket.id"
                  :class="[
                    'ticket-row',
                    {
                      'has-location':
                        ticketLocations &&
                        Object.keys(ticketLocations).length &&
                        getTicketLocation(ticket.id) &&
                        getTicketLocation(ticket.id).length,
                    },
                  ]"
                >
                  <td class="ticketType">
                    {{ ticket.name }}
                  </td>
                  <td class="ticket-count">
                    {{ ticket.count
                    }}{{ ticket.bundleGratisCount ? `+${ticket.bundleGratisCount} GRATIS` : '' }}
                  </td>
                  <td style="text-align: right; padding-right: 0">
                    <span class="single-ticket-price">
                      {{ calculatePrice(ticket) }} {{ ' ' }} {{ ticket.currency }}
                    </span>
                  </td>
                </tr>
                <tr
                  v-for="ticket in countDuplicate(selectedTickets)"
                  v-if="ticketLocations && Object.keys(ticketLocations).length"
                  :key="`${ticket.id}-locations`"
                >
                  <td :colspan="3" class="ticket-location-row">
                    <div v-for="location in getTicketLocation(ticket.id)" :key="location">
                      <p class="ticket-location-text">
                        {{ location }}
                      </p>
                    </div>
                  </td>
                </tr>
                <tr v-if="selectedTicketInsurance && insuranceAmount" class="fixed-fee-row">
                  <td class="ticketType">
                    {{ $t('ticketInsurance') }}
                  </td>
                  <td class="ticketCount">{{ selectedTickets.length }}</td>
                  <td
                    class="single-ticket-price"
                    style="text-align: right; padding-right: 0; font-weight: 400"
                  >
                    {{ insuranceAmount }} EUR
                  </td>
                </tr>
                <tr
                  v-for="[key, value] in Object.entries(fixedFees)"
                  v-if="Object.keys(fixedFees).length"
                  :key="key"
                  class="fixed-fee-row"
                  @click="openCoreEventFeeDescriptionModal = !openCoreEventFeeDescriptionModal"
                >
                  <td class="coreevent-fee-title">
                    {{ $t('coreEventFee') }} {{ round(key * 1.25, 2) }}
                    <img
                      src="/assets/info-rounded.svg"
                      alt="info icon"
                      style="width: 1.5rem; height: 1.5rem"
                    >
                  </td>
                  <td class="ticketCount">{{ value.count }}</td>
                  <td style="text-align: right; padding-right: 0">
                    <span class="single-ticket-price">
                      {{ round(key * value.count * 1.25, 2) }} {{ ' ' }} {{ currency }}
                    </span>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <v-flex
            v-if="promoCode || displayGiftCardCalculation"
            x12
            :class="['header-description', !isZkm && 'header-description-regular']"
            :style="{
              padding: !isZkm && '10px 0',
              borderTop: '1px solid var(--stroke-one, rgba(151, 151, 151, 0.5))',
            }"
          >
            <div class="element-description">
              <div>{{ $t('subtotalPriceLabel') }}</div>
              <div>{{ subTotalPrice }} {{ currency }}</div>
            </div>
            <div v-if="promoCode" class="element-description">
              <div>{{ $t('orderDiscount') }}</div>
              <div>-{{ discountedPrice.toFixed(2) }} {{ currency }}</div>
            </div>
            <div v-if="displayGiftCardCalculation" class="element-description">
              <div>{{ $t('giftCardDiscount') }}</div>
              <div>-{{ Number(giftCard.amount).toFixed(2) }} {{ currency }}</div>
            </div>
          </v-flex>
          <v-flex
            v-if="hasCoreEventFee && isZkm && calculateCoreEventFixedFee() > 0"
            x12
            class="header-description"
            :style="{
              borderTop: '1px solid var(--stroke-one, rgba(151, 151, 151, 0.5))',
            }"
          >
            <div
              class="element-description"
              @click="openCoreEventFeeDescriptionModal = !openCoreEventFeeDescriptionModal"
            >
              <div>{{ $t('coreEventFee') }}:</div>
              <div>{{ calculateCoreEventFixedFee() }} {{ currency }}</div>
            </div>
          </v-flex>
        </div>
      </v-layout>
    </v-flex>
    <div v-if="showWarChildNotice && shoppingCart.length" class="war-child-notice">
      <p>
        Fontaines D.C. are supporting War Child UK. €1 from every ticket sold will help War Child to
        protect, educate, and stand up for the rights of children affected by war.
      </p>
      <a href="https://www.warchild.org.uk" target="_blank" rel="noopener noreferrer">
        www.warchild.org.uk
      </a>
      <p>Included in the CoreEvent fee.</p>
    </div>
    <div class="total-price-description-regular-container">
      <div class="total-price-description-regular">
        <div class="total-price-container">
          <p class="total-price-label">{{ $t('inTotal') }}</p>
          <span class="total-price"> {{ totalPrice }} {{ currency }} </span>
        </div>
        <main-button
          id="continuePurchaseButton"
          depressed
          class="checkout-submit-button"
          color="#333"
          :disabled="isSubmitDisabled"
          @click="handleSubmit()"
        >
          <span>{{ activeStep === 1 ? $t('continueShoppingCart') : $t('confirmOrder') }}</span>
          <img
            v-if="!isSubmitDisabled"
            class="checkout-submit-button__icon"
            src="/assets/checkout-confirm-arrow.svg"
            alt=""
          >
        </main-button>
      </div>
      <div v-if="!isAuthenticated && activeStep !== 1" class="not-logged-in">
        <button type="button" class="not-logged-in__link" @click="$emit('signIn')">
          {{ $t('signInToContinue') }}
        </button>
      </div>
    </div>
    <core-event-fee-description-modal
      v-if="openCoreEventFeeDescriptionModal"
      @close="openCoreEventFeeDescriptionModal = !openCoreEventFeeDescriptionModal"
    />
  </v-layout>
</template>

<script>
import { round, format } from 'mathjs'
import { exchangeRate } from '@/utils'
import { OrganizationCustomTicketFee } from '@/types'
import { first, minBy } from 'lodash'
import i18next from 'i18next'
import CoreEventFeeDescriptionModal from '@/components/tickets/core-event-fee-description-modal.vue'
import { mapGetters } from 'vuex'

const PromoCodeDiscountType = Object.freeze({
  AMOUNT: 'AMOUNT',
  PERCENTAGE: 'PERCENTAGE',
})
const INSURANCE_PERCENTAGE = 0.1
const CORE_EVENT_FEE_EXEMPT_EVENT_IDS = [8595, 8693]
const WAR_CHILD_NOTICE_EVENT_IDS = [9501, 9502, 9503, 9648]
const TABLE_ROW_LOCATION_ORDER_ITEM_IDS = [26836, 24683]
const SPECIAL_TABLE_LOCATION_EVENT_IDS = [7345, 9022]

export default {
  name: 'ticket-price-list',
  components: {
    CoreEventFeeDescriptionModal,
  },
  props: {
    selectedTickets: {
      type: Array,
      default: () => {
        return []
      },
    },
    promoCode: {
      type: Object,
      default: null,
    },
    ticketLocations: {
      type: Object,
      default: null,
    },
    event: {
      type: Object,
      default: null,
    },
    membership: {
      type: Object,
      default: null,
    },
    startTime: {
      type: Date,
    },
    subscription: {
      type: Array,
      default: () => [],
    },
    shoppingCart: {
      type: Array,
      default: () => {
        return []
      },
    },
    activeStep: {
      type: Number,
      default: null,
    },
    user: {
      type: Object,
      default: null,
    },
    giftCard: {
      type: Object,
      default: null,
    },
    hideEditButton: {
      type: Boolean,
      default: false,
    },
    selectedTicketInsurance: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      exchangeRate: exchangeRate,
      subTotalPrice: this.calculateSubTotalPrice(),
      fixedFees: {},
      discountedPrice: this.calculateDiscountedPrice(),
      totalPrice: this.calculateTotalPrice(),
      currency: first(this.selectedTickets).currency,
      eventColor: this.event.eventTemplateId
        ? '#333'
        : this.getThemeStyle(this.event.coverImagePrimaryColor, null, 'primary'),
      openCoreEventFeeDescriptionModal: false,
      disabledSubmitButton: false,
      insuranceAmount: null,
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
    }),
    isZkm() {
      return this.event.organization.id == process.env.VUE_APP_ZKM_ORGANIZATION_ID
    },
    showWarChildNotice() {
      return WAR_CHILD_NOTICE_EVENT_IDS.includes(Number(this.event && this.event.id))
    },
    hasCoreEventFee() {
      let promoCodeTickets = 0

      return this.selectedTickets.some(ticket => {
        let ticketPrice = Number(ticket.price)
        if (this.checkPromoCode(promoCodeTickets, ticket)) {
          promoCodeTickets++
          ticketPrice =
            this.promoCode.discountType === PromoCodeDiscountType.AMOUNT
              ? ticket.price - this.promoCode.discountAmount
              : round(ticket.price - (ticket.price * this.promoCode.discountPercentage) / 100, 2)
        }

        return this.getCoreEventFeeForSelectedTicket(ticketPrice) > 0
      })
    },
    displayGiftCardCalculation() {
      return this.giftCard && this.giftCard.amount && this.giftCard.isInRange
    },
    isTicketMinimumValid() {
      let valid = true
      this.countDuplicate(this.selectedTickets).forEach(ticket => {
        if (
          ticket.itemMeta &&
          ticket.itemMeta.min &&
          ticket.count > 0 &&
          ticket.count < ticket.itemMeta.min
        ) {
          valid = false
        }
      })

      return valid
    },
    isSubmitDisabled() {
      return (
        (this.activeStep !== 1 && (this.disabledSubmitButton || !this.isAuthenticated)) ||
        (this.activeStep === 1 && !this.isTicketMinimumValid)
      )
    },
  },
  watch: {
    selectedTickets: {
      handler(_) {
        this.recalculatePrices()
      },
    },
    promoCode: {
      handler(_) {
        this.recalculatePrices()
      },
    },
    giftCard: {
      handler(_) {
        this.totalPrice = this.calculateTotalPrice()
      },
    },
    selectedTicketInsurance: {
      handler(_) {
        this.totalPrice = this.calculateTotalPrice()
      },
    },
  },
  mounted() {
    this.calculateCoreEventFixedFee()
  },
  methods: {
    getFixedFeeForSelectedTicket(ticketPrice) {
      let ticketFee =
        this.event.fixedFeePerTicket ||
        (this.event.organization && this.event.organization.fixedFeePerTicket) ||
        0
      const customOrganizationFees = OrganizationCustomTicketFee[Number(this.event.organization.id)]
      if (customOrganizationFees) {
        ticketFee = this.getTicketFee(ticketPrice, customOrganizationFees)
      }

      return ticketFee
    },
    getVariableFeePercentage() {
      return Number(
        this.event.variableFeePercentage ||
          (this.event.organization && this.event.organization.variableFeePercentage) ||
          0,
      )
    },
    getCoreEventFeeForSelectedTicket(ticketPrice) {
      if (CORE_EVENT_FEE_EXEMPT_EVENT_IDS.includes(Number(this.event.id))) {
        return 0
      }

      const normalizedTicketPrice = Number(ticketPrice)
      if (
        !Number.isFinite(normalizedTicketPrice) ||
        normalizedTicketPrice <= 0
      ) {
        return 0
      }

      const fixedFee = this.getFixedFeeForSelectedTicket(normalizedTicketPrice)
      const variableFee =
        normalizedTicketPrice > 0
          ? (normalizedTicketPrice * this.getVariableFeePercentage()) / 100
          : 0

      return round(fixedFee + variableFee, 2)
    },
    round,
    getTicketFee(price, organizationFees) {
      let ticketFee = 0
      for (const key in organizationFees) {
        const ranges = organizationFees[key]
        if (price >= ranges.min && price <= ranges.max) {
          return (ticketFee = Number(key))
        }
      }

      return ticketFee
    },
    getTicketLocation(ticketId) {
      const locations = []
      if (!this.ticketLocations[ticketId]) {
        return
      }
      this.ticketLocations[ticketId].map(location =>{
        let section = location['section']
        let row = location['row']
        const displayRowAsTable = TABLE_ROW_LOCATION_ORDER_ITEM_IDS.includes(Number(ticketId))
        let seat = location.isTable ? 'Table' : 'Seat'
        let seatsLocation = `${seat}-${location['seats'].join(',')}`
        const currentLanguage = i18next.language

        if (displayRowAsTable) {
          row = row.replace('Row', 'Table')
        } else if (SPECIAL_TABLE_LOCATION_EVENT_IDS.includes(Number(this.event.id))) {
          row = row.replace('Row', currentLanguage === 'hr' ? 'Stol' : 'Table')
        }

        locations.push(
          `${section} / ${row} ${
            SPECIAL_TABLE_LOCATION_EVENT_IDS.includes(Number(this.event.id)) || displayRowAsTable
              ? ''
              : `/ ${seatsLocation}`
          }`,
        )
      })

      return locations
    },

    transformSeatString(seatString) {
      seatString = seatString
        .replace(/Section-|-/g, '')
        .replace(/(\d+)_Row/g, 'Red ')
        .replace('Seat', '/ Sjedalo ')
        .replace('_', ' ')

      return seatString
    },
    recalculatePrices() {
      this.subTotalPrice = this.calculateSubTotalPrice()
      this.totalPrice = this.calculateTotalPrice()
      this.discountedPrice = this.calculateDiscountedPrice()
    },
    calculatePrice(ticket) {
      return (Math.round(ticket.count * ticket.price * 100) / 100).toFixed(2)
    },
    calculateSubTotalPrice() {
      return this.selectedTickets
        .reduce((sum, ticket) => sum + parseFloat(ticket.price), 0)
        .toFixed(2)
    },
    calculateCoreEventFixedFee() {
      this.fixedFees = {}
      let promoCodeTickets = 0
      let totalCoreEventFee = 0
      this.selectedTickets.map(t => {
        let ticketPrice = Number(t.price)
        if (this.checkPromoCode(promoCodeTickets, t)) {
          promoCodeTickets++
          ticketPrice =
            this.promoCode.discountType === PromoCodeDiscountType.AMOUNT
              ? t.price - this.promoCode.discountAmount
              : round(t.price - (t.price * this.promoCode.discountPercentage) / 100, 2)
        }
        const coreEventFee = this.getCoreEventFeeForSelectedTicket(ticketPrice)
        if (!coreEventFee) {
          return
        }
        const existingFee = this.fixedFees[coreEventFee]
        if (existingFee) {
          existingFee.count += 1
        } else {
          this.fixedFees[coreEventFee] = { count: 1 }
        }
        totalCoreEventFee += round(coreEventFee * 1.25, 2)
      })

      return round(totalCoreEventFee, 2)
    },
    calculateTotalPrice() {
      let promoCodeTickets = 0
      const selectedTicketsWithPrepaidCoupon = this.selectedTickets.filter(t => t.prepaidCoupon)
      let subscriptionTicketWithLowestPrice =
        this.subscription.length &&
        this.subscription[0].couponItemId &&
        selectedTicketsWithPrepaidCoupon.length
          ? minBy(selectedTicketsWithPrepaidCoupon, ticket => {
            return Number(ticket.price)
          }).price
          : 0
      const ticketsPrice = this.selectedTickets.reduce((sum, ticket) => {
        if (this.checkPromoCode(promoCodeTickets, ticket)) {
          promoCodeTickets++

          return (
            sum +
            (this.promoCode.discountType === PromoCodeDiscountType.AMOUNT
              ? ticket.price - this.promoCode.discountAmount
              : round(ticket.price - (ticket.price * this.promoCode.discountPercentage) / 100, 2))
          )
        } else {
          return sum + parseFloat(ticket.price)
        }
      }, 0)

      const coreEventPrice = this.calculateCoreEventFixedFee()

      const giftCardPrice = this.displayGiftCardCalculation ? Number(this.giftCard.amount) : 0

      const totalPrice = round(
        ticketsPrice - Number(subscriptionTicketWithLowestPrice) + coreEventPrice - giftCardPrice,
        2,
      )

      if (this.selectedTicketInsurance) {
        this.insuranceAmount = this.roundPrice(totalPrice * INSURANCE_PERCENTAGE)

        return round(totalPrice * (1 + INSURANCE_PERCENTAGE), 2)
      }

      this.insuranceAmount = this.roundPrice(totalPrice * INSURANCE_PERCENTAGE)
      this.$emit('updateTicketInsuranceAmount', this.insuranceAmount)

      return totalPrice
    },
    roundPrice(value) {
      return format(round(value, 2), { notation: 'fixed', precision: 2 })
    },
    calculateDiscountedPrice() {
      let promoCodeTickets = 0

      return this.selectedTickets.reduce((sum, ticket) => {
        if (this.checkPromoCode(promoCodeTickets, ticket)) {
          promoCodeTickets++

          return (
            sum +
            (this.promoCode.discountType === PromoCodeDiscountType.AMOUNT
              ? this.promoCode.discountAmount
              : round(parseFloat(ticket.price) * (this.promoCode.discountPercentage / 100), 2))
          )
        } else {
          return sum
        }
      }, 0)
    },
    getTotalPrice() {
      return `${this.currency} ${this.totalPrice}`
    },
    countDuplicate() {
      return Object.values(
        this.selectedTickets.reduce((ticketsWithCountObject, ticket) => {
          let ticketIdKey = `${ticket.id}`
          if (!ticketsWithCountObject[ticketIdKey]) {
            if (ticket.bundleOfferId) {
              ticketsWithCountObject[ticketIdKey] = { ...ticket, count: 0, bundleGratisCount: 1 }
            } else {
              ticketsWithCountObject[ticketIdKey] = { ...ticket, count: 1, bundleGratisCount: 0 }
            }
          } else {
            if (ticket.bundleOfferId) {
              ticketsWithCountObject[ticketIdKey].bundleGratisCount += 1
            } else {
              ticketsWithCountObject[ticketIdKey].count += 1
              if (!ticketsWithCountObject[ticketIdKey].price && ticket.price) {
                ticketsWithCountObject[ticketIdKey].price = ticket.price
              }
            }
          }

          return ticketsWithCountObject
        }, {}),
      )
    },
    checkPromoCode(promoCodeTicketsCount, ticket) {
      return (
        this.promoCode &&
        this.promoCode.orderItems.map(oi => oi.id).includes(ticket.id) &&
        promoCodeTicketsCount <
          (typeof this.promoCode.remainingTickets === 'number'
            ? this.promoCode.remainingTickets
            : this.promoCode.ticketsPerOrder) &&
        (this.promoCode.orderItems.find(oi => oi.id === ticket.id).OrderItemPromoCode.quantity >
          0 ||
          this.promoCode.orderItems.find(oi => oi.id === ticket.id).OrderItemPromoCode.unlimited)
      )
    },
    trackTicketsPurchase(cart) {
      // Meta Pixel is only loaded with marketing cookie consent.
      if (!window.fbq) {
        return
      }

      const mappedTickets = cart.map(ticket => ({
        content_name: ticket.name,
        content_category: 'Event Ticket',
        content_ids: [ticket.id],
        content_type: 'product',
        value: parseFloat(ticket.price),
        currency: ticket.currency,
      }))

      mappedTickets.forEach(ticket => {
        window.fbq('track', 'Cart', ticket)
      })
    },
    handleSubmit() {
      this.$emit('triggerClick')
      if (
        this.event.extraModules.ticketing &&
        this.shoppingCart.length !== 0 &&
        this.activeStep !== 1
      ) {
        this.trackTicketsPurchase(this.shoppingCart)
        this.$emit('triggerPayment')
      }
    },
  },
}
</script>

<style scoped>
.zkm-layout-container {
  width: 100%;
}

.regular-layout-container {
  padding: 1rem 1.5rem 0 1.5rem;
  max-width: 389px;
}

.ticketType {
  width: 20px !important;
  word-break: break-word;
  color: var(--Grey-00, #333);
  font-family: 'Source Sans Pro';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 24px */
  hyphens: auto;
}

.seatRow {
  color: var(--grey-10, #666);
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 500;
  padding-top: 0.5rem !important;
  line-height: 120%;
}

.ticketType li {
  list-style: none;
  padding: 0;
  margin: 0;
}

.timer-zkm {
  border: solid var(--grey-00, #333);
  border-width: 0 0 2px 0;
  margin-top: 0;
  margin-bottom: 2rem;
}

.single-ticket-price {
  color: var(--Grey-00, #333);
  text-align: right;
  font-family: 'Source Sans Pro';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 24px */
  text-transform: uppercase;
}
.ticket-count {
  color: var(--Grey-00, #333);
  text-align: right;

  /* Body/Small */
  font-family: 'Source Sans Pro';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 24px */
}

.header-title {
  text-transform: uppercase;
  color: var(--Grey-00, #333);
  font-family: 'Source Sans Pro';
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 14.4px */
}

.wp-table {
  width: 100%;
  margin-top: 1rem;
  border-collapse: collapse;
  table-layout: fixed;
}

.wp-table tr {
  border-bottom: 1px solid var(--stroke-one, rgba(151, 151, 151, 0.5));
}

.wp-table th:first-child,
.wp-table td:first-child {
  word-break: keep-all;
}

.wp-table th:nth-child(2),
.wp-table td:nth-child(2) {
  padding-right: 2rem;
  text-align: right;
  @media screen and (max-width: 800px) {
    padding-right: 1rem;
  }
  @media screen and (max-width: 400px) {
    padding-right: 2rem;
  }
  margin: auto;
}

.wp-table tr:last-child {
  border-bottom: none;
}

.wp-table td {
  font-weight: bold;
}

.ticket-row.has-location {
  border-bottom: none;
}

.ticket-location-row {
  padding-top: 0 !important;
}

.ticket-location-text {
  word-break: break-word;
  font-weight: normal;
  color: #666;
  margin: 0.5rem 0 0 0;
}

.wp-table td,
.wp-table th {
  padding: 8px 8px;
  display: table-cell;
  text-align: left;
  vertical-align: top;
  color: #333333;
}

.layout-zkm {
  margin-top: 2rem;
}

.zkm-price-layout {
  width: 100%;
}

.total-price-description-zkm {
  background-color: #f5f5f5;
  width: 100%;
  padding: 1rem 1.5rem;
  border: solid var(--grey-00, #333);
  border-width: 2px 0 0 0;
}

.war-child-notice {
  width: 100%;
  padding: 16px 24px;
  border-top: 1px solid var(--stroke-one, rgba(151, 151, 151, 0.5));
  background-color: #fff;
  color: var(--Grey-00, #333);
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.2;
  overflow-wrap: break-word;
}

.war-child-notice p {
  margin: 0;
}

.war-child-notice a {
  display: block;
  color: #0277bd;
  text-decoration: underline;
  text-underline-position: from-font;
}

.war-child-notice + .total-price-description-regular-container {
  margin-top: 0;
}

.total-price-description-regular-container {
  background-color: #f5f5f5;
  width: 100%;
  margin-top: 0.5rem;
  align-items: center;
  @media screen and (max-width: 992px) {
    position: fixed;
    bottom: 0;
  }
}

.total-price-description-regular {
  padding: 1rem 1.5rem;
  width: 100%;
  background-color: #f5f5f5;
  border-top: 1px solid var(--stroke-one, rgba(151, 151, 151, 0.5));
}

.checkout-submit-button {
  width: 100%;
  margin-top: 1rem;
}

.checkout-submit-button__icon {
  display: none;
}

.zkmButton {
  border-radius: 0;
  width: 100%;
  margin: 1rem;
}

.ticket-price-container-step-zkm {
  position: relative;
  border: solid var(--grey-00, #333);
  border-width: 0 0 2px 0;
  border-radius: 0;
  padding: 0;
}

.ticket-price-container-step-regular {
  flex-direction: column;
  border-radius: 4px;
  max-width: 389px;
  border: 1px solid var(--stroke-one, rgba(151, 151, 151, 0.5));
  margin-top: 1.5rem;
  @media screen and (max-width: 992px) {
    width: calc(100vw - 24px);
    max-width: none;
    margin-left: calc(50% - 50vw + 12px);
    margin-right: 0;
    border: unset;
  }
  @media screen and (min-width: 993px) {
    margin-right: 1.5rem;
  }
}
.cart-title {
  color: var(--Grey-00, #333);
  font-variant-numeric: lining-nums proportional-nums;

  /* Heading/H5 */
  font-family: Raleway;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 24px */
  letter-spacing: -0.6px;
}
@media screen and (max-width: 992px) {
  .ticket-price-container-step {
    margin: 12px;
    margin-bottom: 30px;
  }
}

@media (min-width: 992px) and (max-width: 1440px) {
  .ticket-price-container-step {
    border-radius: 8px 0 0 8px;
  }
}

.header-description {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 16px;
  color: #665f5c;
  line-height: 20px;
  margin-bottom: 12px;
  padding: 10px 20px 10px 10px;
  display: flex;
  flex-direction: column;
}

.header-description-zkm {
  width: 100%;
}

.header-description-regular {
  padding: 0;
  margin: 0;
}

.zkm-price-table {
  width: 100%;
}

.wp-table {
  width: 100%;
  table-layout: fixed;
}

.ticket-list-header th:first-child {
  width: 50%;
  white-space: nowrap;
}

.ticket-list-header th:nth-child(2) {
  width: 20%;
}

.ticket-list-header th:nth-child(3) {
  width: 30%;
}

.element-description {
  display: flex;
  column-gap: 0.5rem;
  justify-content: space-between;
  margin-bottom: 8px;
}

.price-container-title {
  color: #ff4c00;
  font-family: Raleway, sans-serif;
  font-weight: bold;
  font-size: 18px;
  padding-left: 10px;
}

.price-container-title-zkm {
  color: #333333;
}

.price-container-title-regular {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  align-self: stretch;
  max-width: 389px;
  color: #333333;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Source Sans Pro;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.045rem;
}

.total-price-description {
  font-size: 18px;
  font-weight: bold;
  line-height: 23px;
  color: #333333;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 10px;
}

.total-price-label {
  color: var(--Grey-00, #333);
  font-family: 'Source Sans Pro';
  font-size: 16px;
  font-style: normal;
  margin: 0;
  text-transform: uppercase;
  font-weight: 400;
  line-height: 150%; /* 24px */
}
.total-price-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.total-price {
  display: block;
  color: var(--Grey-00, #333);
  text-align: right;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 24px */
  letter-spacing: -0.6px;
  text-transform: uppercase;
}

.edit-cart {
  display: flex;
  align-items: center;
  border-radius: 24px;
  margin-right: 0;
  border: 2px solid var(--Grey-00, #333);
  color: var(--Grey-00, #333);
  font-variant-numeric: lining-nums proportional-nums;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Raleway;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%; /* 19.2px */
  letter-spacing: 0.24px;
  text-transform: uppercase;
}

.edit-cart:hover {
  cursor: pointer;
}

.coreevent-fee-title {
  display: flex !important;
  align-items: center;
  gap: 0.38rem;
  word-break: auto-phrase;
  color: var(--Grey-00, #333);
  font-family: 'Source Sans Pro';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 24px */
  hyphens: auto;
}

.fixed-fee-row:hover {
  cursor: pointer;
}

.not-logged-in {
  margin-top: -0.75rem;
  display: flex;
  font-size: 14px;
  justify-content: end;
  background-color: #f5f5f5;
  padding-right: 1rem;
  font-family: Raleway, sans-serif;
  font-style: italic;
  font-style: bold;
  font-weight: bold;
  color: #666;
  @media screen and (max-width: 992px) {
    padding-right: 2.5rem;
    margin-top: -0.75rem;
  }
}

.not-logged-in__link {
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  text-decoration: underline;
  cursor: pointer;
}

@media screen and (max-width: 992px) {
  .ticket-price-container-step-regular .regular-layout-container {
    width: 100%;
    max-width: none;
  }

  .ticket-price-container-step-regular .total-price-description-regular-container {
    left: 12px;
    right: 12px;
    width: auto;
  }

  .total-price-description-regular-container {
    margin-top: 0;
  }

  .checkout-submit-button {
    height: 2.875rem;
    margin-top: 1rem;
  }

  .checkout-submit-button__icon {
    display: block;
    width: 1.5rem;
    height: 1.5rem;
    margin-left: 0.625rem;
  }

  .not-logged-in {
    justify-content: center;
    margin: 0;
    padding: 0 1rem 1.5rem;
  }
}

.not-logged-in-zkm {
  @media screen and (max-width: 992px) {
    padding-right: 0.25rem !important;
  }
}
</style>
